import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Utilities } from 'app/shared/helpers/utilities';

@Component({
  selector: 'app-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.scss'],
})
export class CheckListComponent implements OnInit {
  form: UntypedFormGroup;
  controls: any[];
  _list: CheckListItem[];

  @Input() multiselect = true;
  @Input() readOnly = false;
  @Input() set list(val: CheckListItem[]){
    if (val){
      this._list = [...val];
      if (this._list && (this._list.length > 0)){
        this.controls = this._list.map((c) => {
          const control = new UntypedFormControl({value: false, disabled: this.readOnly});
          control.setValue(c.checked);
          return control;
        });

        this.form = this.formBuilder.group({
          items: new UntypedFormArray(this.controls),
        });

        setTimeout(() => { Utilities.patchCheckboxAria(); }, 200);
      }
    }
  }

  @Output() onChanged: EventEmitter<CheckListItem> = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit() {
  }

  change(item: CheckListItem){
    if (!this.multiselect){
      let i = 0;
      this._list.forEach((checkListItem) => {
        if (item !== checkListItem){
          this.controls[i].setValue(false);
        }
        i = i + 1;
      });
    }
    this.onChanged.emit(item);
  }

  getId(index){
    if (index < this._list.length) {
      return this._list[index].name.replace(/ /g,'_');
    }
  }
}

// tslint:disable-next-line:max-classes-per-file
export class CheckListItem {
  id: number | string;
  name: string;
  checked: boolean;
  value: any;

  constructor(id: number | string, name: string, checked?: boolean, value?){
    this.id = id;
    this.name = name;
    this.checked = checked || false;
    this.value = value;
  }
}
